// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"tm-z","categoryName":"um-z","categoryImage":"vm-z","categoryContent":"wm-z","bottomAligned":"xm-z"};